/* JETSNUS – teata, kui tagasi laos (2026-10-09) */
(function () {
  if (customElements.get('jl-restock')) return;
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  class JlRestock extends HTMLElement {
    connectedCallback() {
      if (this._ready) return; this._ready = true;
      this.form = this.querySelector('form');
      this.toggle = this.querySelector('.jl-restock__toggle');
      this.panel = this.querySelector('.jl-restock__panel');
      this.msg = this.querySelector('.jl-restock__msg');
      this.ok = this.querySelector('.jl-restock__ok');
      var self = this;
      // kaardil ei tohi klikk avada tootelehte
      ['click', 'mousedown', 'touchstart'].forEach(function (ev) {
        self.addEventListener(ev, function (e) { e.stopPropagation(); }, { passive: true });
      });
      if (this.toggle) this.toggle.addEventListener('click', function (e) {
        e.preventDefault();
        self.removeAttribute('data-collapsed');
        self.panel.hidden = false;
        self.toggle.setAttribute('aria-expanded', 'true');
        var i = self.form && self.form.querySelector('input[type=email]');
        if (i) i.focus();
      });
      if (this.form) this.form.addEventListener('submit', function (e) { self.onSubmit(e); });
      // pärast saatmist tagasi samale lehele koos otsingu/filtri/lehekülje parameetritega
      var ret = this.querySelector('.jl-restock__return');
      if (ret) {
        var qs = location.search.replace(/[?&]customer_posted=true/, '').replace(/^&/, '?');
        var sep = qs ? '&' : '?';
        ret.value = location.pathname + qs + sep + 'customer_posted=true#' + (this.form.id || '');
      }
      this.restoreDone();
    }
    key() { return 'jl-restock-' + this.dataset.variantId; }
    restoreDone() {
      try {
        var pend = sessionStorage.getItem('jl-restock-pending');
        if (pend && pend === this.dataset.variantId && location.search.indexOf('customer_posted=true') !== -1) {
          localStorage.setItem(this.key(), '1'); sessionStorage.removeItem('jl-restock-pending');
        }
        if (localStorage.getItem(this.key())) {
          this.showDone();
          if (location.search.indexOf('customer_posted=true') !== -1 && !JlRestock._scrolled) {
            JlRestock._scrolled = true; var me = this;
            setTimeout(function () { me.scrollIntoView({ block: 'center' }); }, 300);
          }
        }
      } catch (e) {}
    }
    showDone() {
      if (this.toggle) this.toggle.hidden = true;
      this.removeAttribute('data-collapsed');
      this.panel.hidden = false;
      if (this.form) this.form.hidden = true;
      this.ok.hidden = false;
    }
    showMsg(t) { this.msg.textContent = t; this.msg.hidden = !t; }
    onSubmit(e) {
      // Tavaline saatmine, et Shopify robotikaitse (hCaptcha) saaks tööle hakata.
      var input = this.form.querySelector('input[type=email]');
      var email = (input.value || '').trim();
      if (!EMAIL.test(email)) { e.preventDefault(); this.showMsg(this.dataset.msgErr); input.focus(); return; }
      this.showMsg('');
      try { sessionStorage.setItem('jl-restock-pending', this.dataset.variantId); } catch (er) {}
      var btn = this.form.querySelector('[type=submit]');
      if (btn) btn.setAttribute('aria-busy', 'true');
      setTimeout(function () { if (btn) btn.removeAttribute('aria-busy'); }, 8000);
    }
  }
  customElements.define('jl-restock', JlRestock);
})();
